<div *ngIf="context$ | async as context" class="eb-site-context-selector">
  <div class="eb-site-context-selector__site-links-line">
    <div class="eb-site-context-selector__country-dialog-trigger" (click)="toggleDialog()">
      <cx-icon type="GLOBE"></cx-icon>
      <label data-cy="show-all-countries">{{ context?.activeContext?.country?.name }}</label>
    </div>
    <ng-container
      *ngTemplateOutlet="
        languageSelector;
        context: { items: context?.activeContext, activeContext: context.activeContext }
      "
    ></ng-container>
  </div>
</div>

<ng-template #languageSelector let-items="items" let-active="activeContext">
  <div *ngIf="items" class="eb-site-context-selector__language">
    <label role="link" *ngFor="let item of items?.languages">
      <input
        type="radio"
        (click)="setActiveContext(items, item.isocode)"
        [value]="item.isocode"
        [attr.checked]="
          (activeLanguage$ | async) === item.isocode &&
          (active?.uid === items.uid || active?.uid === items.cmsSite)
        "
      />
      <span class="label" [attr.data-cy]="'change-to-language-' + item.isocode">{{
        item.nativeName
      }}</span>
    </label>
  </div>
</ng-template>
